// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

import SVGInline from 'react-svg-inline'

// INNER IMPORTS
import './ProfileAvatar.css';
import emptyAvatarSVG from "../inlineSVGs/emptyAvatarSVG";
import lightningSlickSVG from "../inlineSVGs/lightningSlickSVG";

const ProfileAvatar = props => (
  <div className="profile-avatar">
      <div className="badge">
          <SVGInline className="lightning" svg={lightningSlickSVG} component="i"/>
      </div>
      <div className="outer-border">
        <div className="inner-border">
            {props.profileImg ?
                <img className="avatar-img" src={props.profileImg} alt="profile"/> :
                <SVGInline className="avatar-empty" svg={emptyAvatarSVG()} component="i"/>
            }
        </div>
      </div>
  </div>
);

ProfileAvatar.propTypes = {
    profileImg: PropTypes.string,
    userName: PropTypes.string
};

export default ProfileAvatar;



// WEBPACK FOOTER //
// ./src/Components/Users/ProfileAvatar.js